<template>
	<div class="view projects">

		<box :label="filteredItems.length+' opgaver'" v-if="filteredItems.length || search_filter">

			<template slot="meta-r">
				<div class="textlink" @click="createNewProject()">Ny opgave</div>
			</template>


			<div class="grid">
				<div class="col m30">
					<inputfield label="Søg">
						<input type="text" placeholder="Søg" :value="search_filter" ref="search_filter" v-on:keyup="search_filter_updated">
					</inputfield>
				</div>
				<div class="col m40">

					<inputfield label="Status">
						<select id="status-select" :value="status_filter" ref="status_filter" v-on:change="status_filter_updated">
							<option value="all">Alle</option>
							<option :value="status_key" v-for="(status,status_key,status_i) in globals.projectStatuses">{{status.title}}</option>
						</select>
						<div class="select-arrow">▾</div>
					</inputfield>

				</div>
				<div class="col m30">

				</div>
			</div>


			<table class="table-a projects-table" v-if="filteredItems.length">
				<thead>
					<tr>
						<th></th>
						<th>Opgave</th>
						<th class="align-l">Kunde</th>
						<th>Status</th>
						<th>Færdig</th>
						<th v-if="false && is_admin" class="align-r">Tid logget/budget</th>
						<th class="align-r" v-if="false && is_admin">Budget kr.</th>
						<th></th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(project,i) in filteredItems">
						<td><avatar :input="project"></avatar></td>
						<td>
							<div class="textlink" @click="gotoProject(project)">{{project.name}}</div>
						</td>
						<td class="align-l">
							<div class="textlink" @click="gotoClient(project)">{{getProjectClient(project).name}}</div>
						</td>
						<td>
							{{getProjectStatus(project)}}
						</td>
						<td>
							{{getProjectDonePct(project)}}%
							&nbsp;
							<minipctbar :pct="getProjectDonePct(project)"></minipctbar>
						</td>
						<td class="align-r" v-if="false && is_admin">
							{{ parseInt(project.timelogs_total_hours) }} /
							{{parseInt(project.budgetted_hours)}} timer
						</td>
						<td class="align-r" v-if="false && is_admin">
							{{outputMoney(project.budget,0)}}
						</td>
						<td>
							<div class="timelog-play-btn" @click="openTimelogger({project_key:project['.key']})"><svgicon icon="ionicons/ios-play"></svgicon></div>
						</td>
					</tr>
				</tbody>
			</table>

			<template v-if="false">
				<pagination :items="filteredItems" :perpage="projects_perpage" :page="projects_currentpage" v-on:updated="paginationUpdate"></pagination>
			</template>



		</box>

		<btn @click.native="createNewProject()" v-if="filteredItems.length">Ny opgave</btn>

	</div>
</template>

<script>
import moment from 'moment'
import helpers from '../helpers.js';
import fdb from '../firebase_config.js';
import mixins from '../mixins.js';
import Box from '.././components/Box'
import Btn from '.././components/Btn'
import Pagination from '.././components/Pagination'
import Datatable from '.././components/Datatable'
import Avatar from '.././components/Avatar'
import Minipctbar from '.././components/Minipctbar'
import Minidonut from '.././components/Minidonut'
import Inputfield from '.././components/Inputfield'
import './../components/generated_svg_icons/ionicons/ios-play'
export default {
	name: 'projects',
	mixins: [ mixins.db, mixins.generic ],
	data: function () {
		return {
			globals: this.$parent.globals,
			projects_currentpage: 1,
			projects_perpage: 25,
		}
	},
	computed: {

		status_filter(){ return globals.projects.status_filter },
		search_filter(){ return globals.projects.search_filter },

		filteredItems(){

			var output = []

			var projects = this.$store.getters['projects/getAll']
			if( !projects ) return output

			var filterString = this.search_filter
			if( !filterString || filterString == undefined || filterString == '' ) filterString = undefined
			if( filterString ) filterString = filterString.toLowerCase()

			for( let project of projects ) {
				
				if( project.archived ) continue

				if( this.status_filter != 'all' ) {
					if( project.status != this.status_filter ) continue;
				}

				var client = this.$store.getters['clients/getClientByProjectKey'](project.key)
				
				//project.timelogs = this.$store.getters['timelogs/getFiltered']({ project_key:project.key })
				//project.timelogs = this.$store.getters['timelogs/getByProject'](project.key)
				//project.timelogs = this.$store.getters['timelogs/get_cached'].projects[project.key]

				//project.timelogs_total_hours = this.$store.getters['timelogs/getTotalHours'](project.timelogs)
				project.budgetted_hours = this.$store.getters['projects/get_budgetted_hours'](project)				
				project.budget = this.$store.getters['projects/getBudget'](project)	
				

				if( filterString ) {
					var match1 = ( project.name && project.name.toLowerCase().indexOf(filterString) >= 0 )
					var match2 = ( client && client.name && client.name.toLowerCase().indexOf(filterString) >= 0 )
					if( !match1 && !match2 ) continue
				}

				output.push(project)
			}

			return output

		},


	}, // computed
	methods: {

		getProjectDonePct: helpers.getProjectDonePct,
		getProjectHoursEstimate: helpers.getProjectHoursEstimate,
		getProjectBudgetTotal: helpers.getProjectBudgetTotal,
		getProjectAcceptedSpec: helpers.getProjectAcceptedSpec,
		getSpecTotalHours: helpers.getSpecTotalHours,
		getSpecTotalBudget: helpers.getSpecTotalBudget,
		outputMoney: helpers.outputMoney,		
		
		gotoProject(project){
			this.$router.push('project/'+project['.key'])
		},
		gotoClient(project){
			this.$router.push('client/'+project.client_key)
		},
		getProjectStatus(project){
			if( !project.status ) return
			if( !this.globals.projectStatuses ) return
			if( !this.globals.projectStatuses[project.status] ) return
			if( !this.globals.projectStatuses[project.status].title ) return
			return this.globals.projectStatuses[project.status].title
		},

		getProjectClient(project){
			var client = { name:undefined }
			//if( project.client_key )
			if( project.client_key && this.$store.state.firebase.clients && this.$store.state.firebase.clients[ project.client_key ] ) client = this.$store.state.firebase.clients[ project.client_key ]
			return client
		},


		search_filter_updated(){
			globals.projects.search_filter = this.$refs.search_filter.value
			globals.projects.status_filter = 'all'
			this.projects_currentpage = 1
		},

		status_filter_updated(){
			globals.projects.status_filter = this.$refs.status_filter.value
			this.projects_currentpage = 1
		},

		createNewProject(){
			var new_entry = fdb.ref('projects').push({
				name: 'Ny opgave',
				hour_rate: 800,
			})
			var new_entry_key = new_entry.getKey()
			this.$router.push('project/'+new_entry_key)
			// create default tasklists: TODO, DOING, DONE
		},

    	openTimelogger(input){ eventBus.$emit('openTimelogger',input) },

	},//methods
	components: { Box, Btn, Avatar, Datatable, Pagination, Minipctbar, Minidonut, Inputfield },
}
</script>



// WEBPACK FOOTER //
// Projects.vue?d86b5bd2